var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeelingBetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00BAA4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H32V32H8V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7626 18.5017C16.7185 17.2999 16.596 16.1744 16.8205 14.985C17.1633 13.1677 15.706 11.3332 14.9003 10.4931C14.0945 9.65305 14.7234 7.86608 16.695 8.67186C18.6665 9.47769 19.8373 11.834 20.0372 12.2782C20.2372 12.7225 20.3036 12.6358 20.5051 12.7532L23.7311 9.52723C24.2579 9.00036 25.1201 9.00036 25.647 9.52723V9.52728C26.1738 10.0542 26.1738 10.9163 25.647 11.4432L25.9927 11.0975C26.5196 10.5705 27.3818 10.5705 27.9086 11.0975C28.4355 11.6243 28.4355 12.4865 27.9086 13.0134L27.5629 13.3591C28.0898 12.8322 28.9519 12.8322 29.4788 13.3591C30.0057 13.886 30.0057 14.7481 29.4788 15.275L29.1534 15.6004C29.6802 15.0735 30.5424 15.0735 31.0693 15.6004C31.5962 16.1273 31.5962 16.9895 31.0693 17.5164L26.4836 22.1021C25.4635 23.1222 23.7576 23.4565 22.7374 24.4766",
    stroke: "#00BAA4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3102 31.2773L22.739 25.8486C23.1162 25.4714 23.1162 24.8542 22.739 24.477L16.7641 18.5021C16.387 18.1249 15.7697 18.1249 15.3925 18.5021L9.32831 24.5663",
    stroke: "#00BAA4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.375 11.4591C13.8728 11.123 14.3921 10.8321 14.927 10.5866M30.2529 18.3483C30.9681 21.8387 29.9722 25.6099 27.2643 28.3178C22.9797 32.6024 16.0329 32.6024 11.7483 28.3178C7.97162 24.5411 7.52471 18.6963 10.406 14.4292M18.204 9.66562C19.8351 9.47175 21.5013 9.64373 23.0701 10.1811",
    stroke: "#00BAA4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4221 20.7472L20.4923 27.8174",
    stroke: "#00BAA4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.006 20.5391L16.0066 20.5385",
    stroke: "#00BAA4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.748 12.8018H11.7487",
    stroke: "#00BAA4",
    strokeWidth: 0.9375,
    strokeMiterlimit: 2.613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelingBetter);
export default __webpack_public_path__ + "static/media/feeling-better.ab53d05d1ed1ae17bb24d8f77ea3c81a.svg";
export { ForwardRef as ReactComponent };